const TokenIcon = ({ ...props }) => {
	return (
		<svg
			{...props}
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.99991 14.0191C4.44843 14.0191 4 14.4675 4 15.019C4 15.5704 4.44843 16.0189 4.99991 16.0189H6.46443L5.77986 18.7572C5.71494 19.0164 5.75498 19.2852 5.89242 19.5142C6.02984 19.7434 6.24808 19.905 6.50687 19.9697C6.58644 19.9897 6.66847 20 6.75025 20C7.20943 20 7.60834 19.6885 7.71963 19.2423L8.52548 16.0189H13.4638L12.7793 18.7572C12.7143 19.0164 12.7544 19.2852 12.8918 19.5142C13.0292 19.7434 13.2475 19.905 13.5063 19.9697C13.5858 19.9897 13.6679 20 13.7496 20C14.2088 20 14.6077 19.6885 14.719 19.2423L15.5249 16.0189H18.9987C19.5502 16.0189 19.9986 15.5704 19.9986 15.019C19.9986 14.4675 19.5502 14.0191 18.9987 14.0191H16.0249L17.0342 9.98183H18.9987C19.5502 9.98183 19.9986 9.53336 19.9986 8.98189C19.9986 8.43042 19.5502 7.98199 18.9987 7.98199H17.5342L18.2187 5.24371C18.2837 4.98444 18.2436 4.71567 18.1062 4.48668C17.9688 4.25744 17.7505 4.09584 17.492 4.03116C17.2337 3.96523 16.9645 4.0048 16.7359 4.14149C16.5062 4.27893 16.3439 4.49815 16.279 4.75864L15.4731 7.98199H10.5348L11.2193 5.24371C11.2843 4.98445 11.2442 4.71567 11.1068 4.48668C10.9694 4.25745 10.7511 4.09584 10.4926 4.03116C10.2341 3.96548 9.96553 4.00527 9.73633 4.14149C9.50683 4.27893 9.3445 4.49815 9.27958 4.75864L8.47373 7.98199H4.99991C4.44843 7.98199 4 8.43042 4 8.9819C4 9.53337 4.44843 9.98183 4.99991 9.98183H7.97373L6.96443 14.0191H4.99991ZM10.0348 9.98183H14.9731L13.9638 14.0191H9.02548L10.0348 9.98183Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export default TokenIcon
